import { Color } from "paper";
export const defaultTriangleEntitySettings = {
    sides: 3,
    radius: 1,
    fillColor: new Color(0, 0, 0),
    defaultPixelSize: 20,
    disabledColor: new Color(0.7, 0.7, 0.7),
};
export const defaultCircleEntitySetttings = {
    radius: 0.5,
    fillColor: new Color(1, 0, 0),
    defaultPixelSize: 10,
};
// Key point colors for profile view
export const KEY_POINT_CIRCLE_COLOR = "#FF0000"; // Red for key points (BP/EP/BC/EC/IP)
export const SLOPE_BREAK_POINT_COLOR = "#FF0000"; // Red for slope break points
// Profile view formatting
export const PROFILE_DISTANCE_DECIMAL_PLACES = 3; // Decimal places for distance display
export const PROFILE_HEIGHT_DECIMAL_PLACES = 3; // Decimal places for height display
export const defaultTerrainPathSettings = {
    strokeColor: new Color("#00FF00"),
    defaultPixelSize: 2,
};
export const defaultFlatGroundOutlineSettings = {
    strokeColor: new Color("red"),
    defaultPixelSize: 2,
};
export const defaultEntityPathSettings = {
    strokeColor: new Color("#00FFFF"),
    defaultPixelSize: 2,
};
export const defaultReferenceLineSettings = {
    strokeColor: new Color("yellow"),
    defaultPixelSize: 2,
};
export const defaultSectionMarkerEntitySettings = {
    stationRadius: 0.6,
    stationColor: defaultTriangleEntitySettings.disabledColor,
    curvePointRadius: 0.8,
    curvePointColor: defaultTriangleEntitySettings.disabledColor,
    selectedColor: new Color("#0000FF"), // same blue as the 3D view's selected marker (Cesium Color.BLUE)
    defaultPixelSize: 14,
};
export const defaultTextSettings = {
    fillColor: new Color(1, 1, 1),
    defaultPixelSize: 15,
};
/** Gap shared by marker-to-label and label-to-dashed-line spacing. */
export const MARKER_LABEL_GAP_PX = 2;
/** Vertical marker label styles; all kinds share the altitude view text size. */
export const defaultMarkerLabelSettings = {
    controlPoint: {
        fontPixelSize: defaultTextSettings.defaultPixelSize,
        clearancePx: defaultTriangleEntitySettings.defaultPixelSize / 2 + MARKER_LABEL_GAP_PX,
    }, // BP/IP/EP
    sectionMarker: {
        fontPixelSize: defaultTextSettings.defaultPixelSize,
        clearancePx: defaultSectionMarkerEntitySettings.defaultPixelSize / 2 +
            MARKER_LABEL_GAP_PX,
    }, // NO.n / BC / EC
};
export const defaultGridLineSettings = {
    defaultPixelSize: 2,
    strokeColor: new Color("#909497"),
};
export const defaultGridTextSettings = {
    defaultPixelSize: 10,
    fillColor: new Color("#909497"),
    lightFillColor: new Color("#dddddd"),
};
export const defaultMeasurementLineSettings = {
    strokeColor: new Color("#ffffff"),
    defaultPixelSize: 2,
};
export const defaultMeasurementTextSettings = {
    fillColor: new Color("#ffffff"),
    defaultPixelSize: 15,
};
export const pixelAttenuationOffset = {
    // Altitue View
    heightTextOffsetAltitudeView: 30,
    totalTextOffsetAltitudeView: 60,
    lentghTextOffsetAltitudeView: 15,
    slopeTextOffsetAltitudeView: 60,
    // Section View
    lentghTextOffsetSectionView: 5,
    slopeTextOffsetSectionView: 10,
};
export const MEASUREMENT_PANEL_HEIGHT_RATIO = 0.15;
export const MEASUREMENT_PANEL_CORNER_ANGLE_THRESHOLD = 1;
export const MEASUREMENT_PANEL_SLOPE_LINE_VERTICAL_PX = 7;
export const MEASUREMENT_PANEL_SLOPE_LINE_DIAGONAL_WIDTH_PX = 30;
export const defaultMeasurementPanelSettings = {
    backgroundColor: new Color("#566573"),
    verticalLineColor: new Color("#ffffff"),
    verticalLineDashPx: [2, 2],
    verticalLinePixelSize: 1,
    panelTopLinePixelSize: 2,
    panelTopLineColor: new Color("#000000"),
    textFillColor: new Color("#ffffff"),
    textPixelSize: 14,
    doubleArrowColor: new Color("#ffffff"),
    doubleArrowPixelSize: 1,
    arrowHeadPixelSize: 5,
};
export const LEGEND_ITEMS = [
    { color: "#00FF00", dataKey: "pointCloudOutlines" },
    { color: "#00FFFF", dataKey: "pathPoints" },
    { color: "#FF00FF", dataKey: "designDataOutlines" },
    { color: "#A52A2A", dataKey: "referenceTopologyOutlines" },
    { color: "#FF0000", dataKey: "flatGroundDataOutlines" },
];
export const defaultLegendSettings = {
    paddingPx: 8,
    itemSpacingPx: 18,
    sampleLineLengthPx: 20,
    sampleLineWidthPx: 2,
    labelOffsetPx: 6,
    labelWidthPx: 100,
    textSizePx: 13,
    textColor: "#ffffff",
    backgroundColor: "rgba(51, 51, 51, 0.7)",
    marginRightPx: 10,
    marginTopPx: 10,
    labels: {
        pointCloudOutlines: "Point Cloud",
        pathPoints: "Object",
        designDataOutlines: "Design Data",
        referenceTopologyOutlines: "2D Drawing",
        flatGroundDataOutlines: "Flat Ground",
    },
};
//# sourceMappingURL=altitude-view-settings.js.map